import gql from 'graphql-tag';

export default gql`
    mutation AddStages($input: AddStagesInput) {
        addStages(input: $input) {
            errors
        }
    }
`;
